module.exports = __webpack_public_path__ + "img/xuqiu.00db081c.png";